import React from 'react'
import DefaultInfoBar from './DefaultInfoBar';
import CustomInfoBar from './CustomInfoBar';
import './EasySoftwareInfoBar.scss'
import { PuxWysiwygHtmlBodyType } from '../PuxWysiwyg/PuxWysiwyg';

interface EasySoftwareInfoBarProps {
  background?: string | null,
  text: PuxWysiwygHtmlBodyType | null,
  resetDate: string | null,
  path?: string
}

const EasySoftwareInfoBar = (props: EasySoftwareInfoBarProps) => {
  const isCustomBar = props.text?.html && props.text.html.length > 0;

  return isCustomBar ? (
    <CustomInfoBar {...props} text={props.text!} />
  ) : (
    <DefaultInfoBar background={props.background} />
  )
}

export default EasySoftwareInfoBar;
